<template>
  <div>
    <div class="main">
      <div class="form-row-parse">
        <!--<div class="form-input-parse">
          <label for="region-input">Управляющая компания</label>
          <select id="region-input" v-model="villageData.user">
            <option v-for="(user, key) in users" :value="user.ID" :key="key">
              {{ user.FIO }}
            </option>
          </select>
        </div>-->
        <div class="form-input-parse">
          <label for="region-input">Регион</label>
          <input id="region-input" type="text" v-model="villageData.region" />
        </div>
        <div class="form-input-parse">
          <label for="district-input">Район</label>
          <input
            id="district-input"
            type="text"
            v-model="villageData.district"
          />
        </div>
        <div class="form-input-parse">
          <label for="name-input">Название</label>
          <input id="name-input" type="text" v-model="villageData.village" />
        </div>
        <div class="form-button-parse">
          <button @click="add" v-show="villageData.village" class="add">
            Добавить
          </button>
        </div>
        <!--<div class="form-button-parse">
          <router-link class="clear" to="/admin/map/addvillage/3">
            <span>Пропустить</span>
          </router-link>
        </div>-->
      </div>
      <div class="form-row-parse">
        <div class="form-button-parse">
          Воспользуйтесь поиском на карте ↓
        </div>
        <div class="form-button-parse" v-show="info">
          {{ info }}
          <router-link
            class="clear"
            :to="'/admin/map/addvillage/3?village_id=' + newVillageId"
          >
            <span>Продолжить</span>
          </router-link>
        </div>
      </div>
    </div>
    <div>
      <yandex-map
        map-type="hybrid"
        :coords="coordsCenter"
        :zoom="12"
        :controls="[]"
        @map-was-initialized="firstMapInit"
      >
        <ymap-marker
          v-for="(item, index) in villageData.geometries"
          :coords="item.coordinates"
          :marker-type="item.type"
          :marker-fill="{ color: '#307c0d', opacity: 0.5 }"
          :options="overlayEditMapOptions"
          :marker-id="index + 1"
          v-bind:key="index + 1"
        />
      </yandex-map>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import { yandexMap, ymapMarker } from "vue-yandex-maps";

export default {
  name: "AddVillageCoord",
  components: { yandexMap, ymapMarker },
  data() {
    return {
      info: null,
      jsonIn: null,
      map: false,
      users: [],
      villageData: {
        user: null,
        country: null,
        region: null,
        district: null,
        village: null,
        geometries: []
      },
      url: config.backend_url,
      coords: [55.755819, 37.617644],
      coordsCenter: [55.755819, 37.617644],
      editPolygon: false,
      editPolygonCenter: false,
      newVillageId: false,
      overlayEditMapOptions: {
        fillColor: "#307c0d",
        strokeColor: "#fcfcfc",
        fillOpacity: 0.5,
        strokeWidth: 1
      }
    };
  },
  computed: {},
  methods: {
    add: function() {
      let self = this;
      let data = {
        url: self.url + "villages/add/",
        data: self.villageData,
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (!data.error) {
          if (data.villages) {
            self.newVillageId = data.villages;
            self.info = "Границы поселка успешно добавлены";
          }
        }
      });
    },
    firstMapInit: function(map) {
      this.map = map;
      this.addMapControls();
    },
    addMapControls: function() {
      let self = this;
      let searchControl = new window.ymaps.control.SearchControl({
        options: {
          provider: "yandex#map"
        }
      });

      searchControl.events.add("resultselect", function(e) {
        searchControl.hideResult();
        let results = searchControl.getResultsArray();
        let selected = e.get("index");
        let addressMeta = results[selected].properties.get("metaDataProperty");
        let address = addressMeta.GeocoderMetaData.Address.Components;

        self.editPolygonCenter = results[selected].geometry.getCoordinates();

        address.forEach(function(item) {
          if (item.kind === "country") self.villageData.country = item.name;
          if (item.kind === "province") self.villageData.region = item.name;
          if (item.kind === "area") self.villageData.district = item.name;
          if (item.kind === "locality") self.villageData.village = item.name;
        });

        self.editPolygon = new window.ymaps.Polygon(
          [],
          {},
          {
            editorDrawingCursor: "crosshair",
            fillColor: "#00FF00",
            fillOpacity: 0.1,
            strokeColor: "#0000FF",
            strokeWidth: 1
          }
        );
        self.map.geoObjects.add(self.editPolygon);
        self.editPolygon.editor.startDrawing();
      });

      let buttonSaveArea = new window.ymaps.control.Button({
        data: { content: "Сохранить границы" },
        options: { maxWidth: 150 }
      });
      buttonSaveArea.events.add("click", function() {
        if (!self.editPolygonCenter) {
          alert("Воспользуйтесь поиском на карте для определения поселка");
        } else {
          let coordinates = self.editPolygon.geometry.getCoordinates();
          if (coordinates[0].length < 1) {
            alert("Нужно разметить границы поселка");
          } else {
            let saveData = {};
            saveData.type = "Polygon";
            saveData.coordsCenter = self.editPolygonCenter;
            saveData.coordinates = coordinates;
            self.editPolygon.editor.stopEditing();
            self.villageData.geometries.push(saveData);
            console.log(saveData);
          }
        }
      });
      this.map.controls.add(buttonSaveArea);
      this.map.controls.add(searchControl);
    },
    getUsers: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "users/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.users = data;
          }
        });
    }
  },
  created() {
    this.getUsers();
  }
};
</script>

<style scoped></style>
